import React, { useRef, useState } from 'react'
import { ReactComponent as AddIcon } from '../../../../assets/svg/add.svg';

import DeviceDropdown from '../DeviceDropdown'

import { IMinimalDevice } from '../../LoanerVehicles';

import styles from './AddNewLoaner.module.scss'

interface IAddNewLoanerProps {
	availableDevices: IMinimalDevice[]
	handleDropdownSelect: (device: IMinimalDevice) => void
}

const AddNewLoaner = ({
	availableDevices,
	handleDropdownSelect,
}: IAddNewLoanerProps) => {
	const [showDropdown, setShowDropdown] = useState(false)
	const triggerRef = useRef<HTMLButtonElement>(null)

  return (
    <div className={styles.addButtonWrapper}>
      <div className={styles.addButtonContainer}>
        {/* Add button */}
        <button
          className={styles.addButton}
          onMouseDown={() => setShowDropdown(!showDropdown)}
					ref={triggerRef}
        >
          <AddIcon />
          <span>Add new</span>
        </button>

        {/* Dropdown */}
        <DeviceDropdown
          devices={availableDevices}
          onSelect={handleDropdownSelect}
          isOpen={showDropdown}
          onClose={() => setShowDropdown(false)}
          placeholder="Search devices to assign..."
					triggerElement={triggerRef.current}
        />
      </div>
    </div>
  )
}

export default AddNewLoaner
